import React, { PropsWithChildren, useMemo } from "react";

import { withConfiguration } from "./ConfigurationContext";
import ConsoleLogging from "./logging/ConsoleLogging";
import SentryLogging from "./logging/SentryLogging";

type logShape = {
  error: $TSFixMeFunction;
  setUser: $TSFixMeFunction;
};

type WithLogType = {
  log?: logShape;
};

const LogContext = React.createContext<WithLogType | null>(null);

type InitializedLogContextProviderProps = {
  configuration?: {
    sentryDSN?: string;
  };
};

function InitializedLogContextProvider({
  children,
  configuration,
}: Readonly<PropsWithChildren<InitializedLogContextProviderProps>>) {
  const LogContextProviderImplementation = configuration?.sentryDSN
    ? SentryLogging
    : ConsoleLogging;

  return (
    <LogContextProviderImplementation>
      {(log) => {
        // FIXME: FALLBACK for old code don't use it!
        // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
        global.log = log;
        // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
        const context = useMemo(() => ({ log }));
        return (
          <LogContext.Provider value={context}>{children}</LogContext.Provider>
        );
      }}
    </LogContextProviderImplementation>
  );
}

const LogContextProvider = withConfiguration(InitializedLogContextProvider);

const withLog = <T extends WithLogType = WithLogType>(
  ChildComponent: React.ComponentType<T>,
) => {
  function ConnectedComponent(props: Readonly<Omit<T, keyof WithLogType>>) {
    return (
      <LogContext.Consumer>
        {
          // istanbul ignore next
          (context = {}) => <ChildComponent {...(props as T)} {...context} />
        }
      </LogContext.Consumer>
    );
  }
  ConnectedComponent.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return ConnectedComponent;
};

const useLog = () => {
  const context = React.useContext(LogContext);
  // istanbul ignore next
  if (!context) {
    throw new Error("useLog must be used inside a LogContextProvider");
  }
  return context.log!;
};

export { LogContextProvider, withLog, type logShape, useLog };
